export default {
  fba: {
    value: 'FBA',
    key: 'fba',
    text: 'FBA',
    disabled: false,
  },
  fbm: {
    value: 'FBM',
    key: 'fbm',
    text: 'FBM',
    disabled: false,
  },
  wfs: {
    value: 'WFS',
    key: 'wfs',
    text: 'WFS',
    disabled: true,
  },
  storage: {
    value: 'STORAGE',
    key: 'storage',
    text: 'Storage',
    disabled: false,
  },
}
